import type {UserEventSpec, UserEventStruct} from '@cohort/shared/schema/apps/userEvent';
import {z} from 'zod';

export const CohortPerkUsedPropertiesSchema = z.object({
  perkId: z.string().uuid(),
  perkAccessId: z.string().uuid(),
  perkIntegrationId: z.string().nullable(), // Can't have PerkIntegrationIdSchema because of circular dependencies
  perkUsageData: z.unknown(),
  perkMetadata: z.record(z.string()),
});
export type CohortPerkUsedProperties = z.infer<typeof CohortPerkUsedPropertiesSchema>;

export type CohortPerkUsedEventStruct = UserEventStruct<
  'cohort.perk.used',
  CohortPerkUsedProperties
>;

export const CohortPerkUsedEventSpec: UserEventSpec<CohortPerkUsedEventStruct> = {
  id: 'cohort.perk.used',
  propertiesSchema: CohortPerkUsedPropertiesSchema,
};
